export default "__VITE_ASSET__EEFY6QP6MkEexmK6_hhzZA__"